import {pxToEm, themeV2} from "@insticator/insticator-ui";

export default theme => ({
    filter: {
        display: 'flex',
        flexWrap: 'nowrap',
        paddingRight: pxToEm(12),
        justifyContent: 'space-between',
        marginTop: themeV2.spacing[2],
        gap: pxToEm(12),
        '& .filter-site': {zIndex: '5',  maxWidth: '17em'},
        '& .filter-device': {zIndex: '1',  maxWidth: '15em',
            '& .divider': { margin: 0},
            '& .name-menuItems .items': {
                height: 'auto'
            }
        },
        '& .filter-country': {zIndex: '1',  maxWidth: '17em'},
        '& .datepickerdropdown': {
            zIndex: '2',
            background: 'white',
            '& .name-dropdown': {
                left: 0,
                '& .toggle': {
                    marginTop: pxToEm(2),
                    maxWidth: 'none',
                    height: pxToEm(22),
                    '& .ball': {
                        height: pxToEm(18),
                        width: pxToEm(18)
                    }
                },
                '& .datepickerapply': {
                    '& .datepicker': {
                        '& .DayPicker': {
                            '& .DayPicker-Months': {
                                flexWrap: 'wrap',
                                justifyContent: 'space-around',
                            }
                        }
                    }
                }
            }
        },
        '& .singleselectdropdown': {
            height: pxToEm(55),
            marginRight: pxToEm(16),
            marginBottom: pxToEm(8)
        },

    },
    filterLabel: {
        fontFamily: "Work Sans",
        fontSize: pxToEm(14),
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: pxToEm(18),
    }
})